export default "__VITE_ASSET__e278e68d__"